import PageSelectDialog from './PageSelectDialog'
import PageList from './../../js-api/PageList'

export default {
	name: 'PageSelect',
	props: {
		value: {
			type: [Number, null]
		}
	},
	data() {
		return {
			dialogOpen: false,
			items: [],
			selectedPage: this.value ? {
				id: this.value,
				title: '読み込み中...',
				description: '',
				pub_date: '',
				exp_date: '',
				url: '',
			} : null,
		}
	},
	components: {
		PageSelectDialog,
	},
	template: `
		<div class="page-select-container">
			<div class="list-group page-select-list-group">
				<button type="button" class="btn-block list-group-item page-select-search-result-item"
					title="変更"
					aria-label="変更"
					@click="openDialog"
				>
					<template v-if="selectedPage">
						<h4>{{selectedPage.title}}</h4>
						<div class="small text-muted">{{selectedPage.url}}</div>
					</template>
					<template v-else>
						<h4 class="text-muted">クリックしてページを選択</h4>
					</template>
				</button>
			</div>
			<PageSelectDialog
				v-if="dialogOpen"
				:value="value"
				@input="onInput"
				@cancel="closeDialog"
			/>
		</div>
	`,
	mounted() {
		PageList.get().then(items => {
			this.items = items
		})
	},
	methods: {
		onInput(value) {
			this.$emit('input', value)
			this.closeDialog()
		},
		openDialog() {
			this.dialogOpen = true
		},
		closeDialog() {
			this.dialogOpen = false
		},
		updateCurrentItem() {
			if (this.value) {
				this.items.filter(item => item.id === this.value)
				.some(item => this.selectedPage = item)
			} else {
				this.selectedPage = null
			}
		},
	},
	watch: {
		items() {
			this.updateCurrentItem()
		},
		value() {
			this.updateCurrentItem()
		},
	},
}
